import React from 'react';
import {CheckCircle} from 'lucide-react';
import {Plan} from "../../api/address.api";
import './BroadbandPlan.css';

interface BroadbandPlanProps {
  plan: Plan;
  selectedPlan: Plan | null;
  onSelect: (plan: Plan) => void;
}

const BroadbandPlan: React.FC<BroadbandPlanProps> = ({ plan, selectedPlan, onSelect }) => {

  const isActive = selectedPlan?.plan_id === plan.plan_id;

  return (
      <div
          className={`w-full bg-white border border-gray-200 rounded-lg col-span-full group md:col-span-1 group hover:bg-fred-blue-600 hover:cursor-pointer shadow-md hover:shadow-xl ${isActive ? 'active' : ''} h-full flex flex-col`}
          onClick={() => onSelect(plan)}>
        {plan.sub_title && (
            <div className="w-full">
              <p className="text-white text-lg bg-fred-blue-600 outline-none font-semibold rounded-t-lg px-2 py-2 inline-flex justify-center items-center w-full text-center">
                {plan.sub_title}
                {plan.recommended && <span className="ml-2 text-sm"> (Recommended)</span>}
              </p>
            </div>
        )}
        <div className={`w-full px-4 sm:px-8 ${plan.sub_title ? '' : 'pt-4'} flex-grow flex flex-col`}>
          <div className='flex justify-between items-center min-h-20'>
            <h5 className={`text-4xl font-semibold text-fred-purple-500 group-hover:text-white ${isActive ? 'active' : ''}`}
            >{plan.name}</h5>
            <CheckCircle className={`hidden w-12 h-12 group-hover:block group-hover:text-white ${isActive ? 'active' : ''}`} />
          </div>
          <div className="flex-grow">
            <p className={`text-base text-gray-500 group-hover:text-gray-100 ${isActive ? 'active' : ''}`}>{plan.description}</p>
          </div>
          <div className={`price flex items-baseline ${isActive ? 'active' : ''}`}>
            <span className="text-3xl font-semibold text-fred-purple-500 group-hover:text-gray-100">$</span>
            <span
                className="text-8xl font-bold text-fred-purple-500 group-hover:text-gray-100">{plan.unlimited_cost_inc_gst ? parseFloat(plan.unlimited_cost_inc_gst) : parseFloat(plan.unlimited_cost || '0')}</span>
            <span className="ms-1 text-xl font-normal text-gray-500 group-hover:text-gray-100">/month</span>
          </div>
          <ul role="list" className={`space-y-5 my-4 flex-grow ${isActive ? 'active' : ''}`}>
            {plan.option_1 && (
                <li className="flex items-center">
                  <CheckCircle className="flex-shrink-0 w-4 h-4 text-fred-blue-500 group-hover:text-gray-100" />
                  <span
                      className="text-base font-normal leading-tight text-gray-500 ms-3 group-hover:text-gray-100">{plan.option_1}</span>
                </li>
            )}
            <li className="flex items-center">
              <CheckCircle className="flex-shrink-0 w-4 h-4 text-fred-blue-500 group-hover:text-gray-100" />
              <span
                  className="text-base font-normal leading-tight text-gray-500 ms-3 group-hover:text-gray-100">{`Average download ${plan.download} mbps`}</span>
            </li>
            <li className="flex items-center">
              <CheckCircle className="flex-shrink-0 w-4 h-4 text-fred-blue-500 group-hover:text-gray-100" />
              <span
                  className="text-base font-normal leading-tight text-gray-500 ms-3 group-hover:text-gray-100">{`Average upload ${plan.upload} mbps`}</span>
            </li>
          </ul>
        </div>
        <div className="mt-auto">
          <button
              type="button"
              className={`text-white text-2xl bg-fred-blue-500 group-hover:bg-fred-purple-500 outline-none font-medium rounded-b-lg px-8 py-4 inline-flex justify-center items-center w-full text-center ${isActive ? 'active' : ''}`}>
            {isActive ? 'Selected' : 'Select Plan'}
          </button>
        </div>
      </div>
  );
};

export default BroadbandPlan;
